"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _constants = require("../constants");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _fieldTransformer = function fieldTransformer(obj, fieldKeys) {
  if (!obj) return obj;
  var objIsArray = Array.isArray(obj);
  return Object.keys(obj).reduce(function (accObj, key) {
    var accum = accObj;
    var googleKey = fieldKeys[key];
    if (googleKey) {
      var googleKeyIsArray = Array.isArray(fieldKeys[key]);
      var value = googleKeyIsArray ? googleKey[1](obj[key]) : obj[key];
      var accumKey = googleKeyIsArray ? googleKey[0] : googleKey;
      accum[accumKey] = value;
      if (_typeof(accum[key]) === 'object') {
        accum[key] = _fieldTransformer(obj[key], fieldKeys);
      }
    } else {
      accum[key] = obj[key];
      if (_typeof(obj[key]) === 'object') {
        accum[key] = _fieldTransformer(obj[key], fieldKeys);
      }
    }
    return accum;
  }, objIsArray ? [] : {});
};
var _default = exports["default"] = function _default(eventName, eventData, guid) {
  var transformedEventName = eventName;
  var transformedData = eventData;
  var isType = !!_constants.typeKeys[eventName];
  var isCheckoutMFE = (eventName === 'checkout' || eventName === 'purchase') && transformedData.ecommerce;
  if (isType && !isCheckoutMFE) {
    transformedEventName = _constants.typeKeys[eventName].keyName || eventName;
    transformedData = _constants.typeKeys[eventName].formatFunc(transformedData);
  }
  var gtmObject = _fieldTransformer(transformedData, _constants.googleFieldKeys);
  var isEnhancedEcommerceOrWishlist = gtmObject.ecommerce || gtmObject.wishlist;
  if (isEnhancedEcommerceOrWishlist) {
    gtmObject = _fieldTransformer(gtmObject, _constants.enchancedEcommerceOrWishlistFieldKeys);
  }
  return _objectSpread(_objectSpread({
    event: transformedEventName
  }, gtmObject), {}, {
    guid: guid
  });
};